/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: PortraitNewline.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  09.12.22 3:01 pm.
 * Last modified: 09.12.22 3:01 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';

const PortraitNewline = () => (
    <span className="egt_lobby_portrait_new_line">
        <br />
    </span>
);

export default PortraitNewline;
